/* =========================
   Formatting utilities
========================= */

export const formatNumber = (num, prefix = '', precision = 2) => {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return '--';
  const n = Number(num);
  const absNum = Math.abs(n);
  if (absNum >= 1e12) return `${prefix}${(n / 1e12).toFixed(precision)}T`;
  if (absNum >= 1e9) return `${prefix}${(n / 1e9).toFixed(precision)}B`;
  if (absNum >= 1e6) return `${prefix}${(n / 1e6).toFixed(precision)}M`;
  if (absNum >= 1e3) return `${prefix}${(n / 1e3).toFixed(precision)}K`;
  return `${prefix}${n.toLocaleString('en-US', { maximumFractionDigits: precision })}`;
};

export const formatVolume = (num) => {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return '--';
  const n = Number(num);
  if (n >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(2)}K`;
  return n.toLocaleString();
};

export const formatPrice = (price, precision = 2) => {
  if (price === null || price === undefined || Number.isNaN(Number(price))) return '--';
  return `USD $${Number(price).toFixed(precision)}`;
};


export const formatPercent = (pct, precision = 2) => {
  if (pct === null || pct === undefined || Number.isNaN(Number(pct))) return '--';
  return `${Number(pct).toFixed(precision)}%`;
};

export const formatDate = (s) => {
  if (!s) return '--';
  const dt = new Date(s);
  return Number.isNaN(dt.getTime())
    ? '--'
    : dt.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

// Smart number formatting function
export const formatSmartNumber = (num) => {
  if (!num || num === 0) return '0';
  
  const absNum = Math.abs(num);
  
  if (absNum >= 1e12) {
    return (num / 1e12).toFixed(1) + 'T';
  } else if (absNum >= 1e9) {
    return (num / 1e9).toFixed(1) + 'B';
  } else if (absNum >= 1e6) {
    return (num / 1e6).toFixed(1) + 'M';
  } else if (absNum >= 1e3) {
    return (num / 1e3).toFixed(1) + 'K';
  } else {
    return num.toLocaleString();
  }
};